import { logWebHrError } from "@/core/logger/log-wrapper";

const { superfund } = require('@/core/svc-client');

const beforeInput = (data) => data;

const beforeCreate = (data) => {
  if (!data) {
    return {
      value: null,
      valueObj: null,
    };
  }

  if (typeof data === 'string') {
    return {
      value: data,
      valueObj: null,
    };
  }

  if (typeof data.value === 'string') {
    return {
      value: data.value,
      valueObj: data.valueObj,
    };
  }

  let value;
  let valueObj;
  if (data.value && data.value.ProductName) {
    value = data.value.ProductName;
    valueObj = data.value || data.valueObj;
  } else if (data.valueObj) {
    value = data.valueObj.ProductName;
    valueObj = data.valueObj || data.value;
  }

  return {
    value,
    valueObj,
  };
};

const beforeSave = ({ valueObj }) => {
  return {
    superfundAUValue: {
      USI: valueObj?.USI,
      ABN: valueObj?.ABN,
      ProductName: valueObj?.ProductName,
      brandId: valueObj?.brandId,
    },
  };
};

const toPrint = (data) => {
  const value = data.value || {};
  const valueObj = data.valueObj || {};
  return `${valueObj.ProductName || value.ProductName} (USI: ${
    valueObj.USI || value.USI
  } / ABN: ${valueObj.ABN || value.ABN})`;
};

const external = async (string) => {
  if (!string) {
    return [];
  }

  try {
    const result = await superfund.get(string);

    const r = result.map((d) => ({
      id: d.usi,
      description: `${d.productName} (USI: ${d.usi})`,
      USI: d.usi,
      ABN: d.abn,
      ProductName: d.productName,
      brandId: d.brandId,
    }));

    return r;
  } catch (e) {
    if (e?.response?.status !== 404) {
      logWebHrError({
        message: 'Failed to load superfund due to error',
        source: 'superfund_au',
        error: e,
      });
    }
  }

  return [];
};

const type = 'autocomplete';

export { beforeInput, external, beforeCreate, beforeSave, toPrint, type };
